import { observer } from 'mobx-react'
import React, { useEffect } from 'react'

import { useGetScheduledPipelineItemsCountFromCache } from '@flowwai-frontend/bps-officer-web/common/data-access'
import { useNotificationsStore } from '@flowwai-frontend/bps-officer-web/notifications'
import {
   DefaultExpandableNavItem,
   DefaultNavItem,
   NavItemModel,
   useNavbarStore
} from '@flowwai-frontend/bps-officer-web/navbar-base'

import {
   DASHBOARDS,
   NOTIFICATIONS,
   PINNED
} from '../../constants/NavItemConstants'

import { containerClassName } from './styles'
import useGetApplicationNavItems from './useGetApplicationNavItems'

const ApplicationNavItemsController = (): React.ReactElement => {
   const navbarStore = useNavbarStore()
   const pinnedPipelineItemsCount = useGetScheduledPipelineItemsCountFromCache()

   const applicationNavItems = useGetApplicationNavItems()

   const { unReadNotificationsCount } = useNotificationsStore()

   useEffect(() => {
      applicationNavItems.setApplicationNavItems()
   }, [])

   useEffect(() => {
      const hasPinnedNavItem = navbarStore.hasNavItem(PINNED)
      if (!hasPinnedNavItem) return

      const pinnedBoard = navbarStore.getNavItem(PINNED)

      const pinnedCount =
         pinnedPipelineItemsCount === undefined
            ? null
            : pinnedPipelineItemsCount

      pinnedBoard.setCount(pinnedCount)
   }, [pinnedPipelineItemsCount])

   const setUnreadNotificationsCount = (): void => {
      const hasNotifications = navbarStore.hasNavItem(NOTIFICATIONS)
      if (!hasNotifications) return

      const notifications = navbarStore.getNavItem(NOTIFICATIONS)

      notifications.setCount(unReadNotificationsCount)
   }

   useEffect(setUnreadNotificationsCount, [unReadNotificationsCount])

   const onActiveNavItem = (itemId: string): void => {
      navbarStore.openAllParentNavItems(itemId)
   }

   const isExactMatch = (id: string): boolean => !(id === DASHBOARDS)

   const renderNavItem = (item: NavItemModel): React.ReactElement => {
      const hasNoChild = item.children.length === 0

      if (hasNoChild) {
         return <DefaultNavItem key={item.id} item={item} />
      }

      return (
         <DefaultExpandableNavItem
            key={item.id}
            item={item}
            onActiveNavItem={onActiveNavItem}
            isExactMatch={isExactMatch}
         />
      )
   }

   return (
      <div className={containerClassName}>
         {navbarStore.applicationNavItems.map(item => renderNavItem(item))}
      </div>
   )
}

export default observer(ApplicationNavItemsController)
